import * as React from 'react';
import Box from '@mui/material/Box';
import { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { getApi, patchApi } from 'views/services/api';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router';
import EditHotel from './Components/EditHotel';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: 'left',
  color: theme.palette.text.secondary
}));

export default function HotelProfile() {
  const [openEdit, setOpenEdit] = useState(false);
  const [hotelData, setHotelData] = useState({});
  const [value, setValue] = useState('1');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const hotel = JSON.parse(localStorage.getItem('hotelData'));

  const handleOpenEditHotel = () => setOpenEdit(true);
  const handleCloseEditHotel = () => setOpenEdit(false);

  const fetchHotelData = async () => {
    try {
      const response = await getApi(`api/hotel/view/${hotel?.hotelId}`);
      setHotelData(response?.data);
      localStorage.setItem('hotelData', JSON.stringify(response?.data))
    } catch (error) {
      console.error('Error fetching hotel data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHotelData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openEdit]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeForCheckInButton = async (event) => {
    const newCheckedValue = event.target.checked;
    setHotelData((prevData) => ({ ...prevData, checkInButtonStatus: newCheckedValue }));

    try {
      const response = await patchApi(`api/hotel/editCheckInButtonStatus/${hotel?.hotelId}`, {
        status: newCheckedValue
      });
      console.log('Check-In Response:', response);
    } catch (error) {
      console.error('Error updating check-in status:', error);
    }
  };

  const handleChangeForCheckOutButton = async (event) => {
    const newCheckedValue = event.target.checked;
    setHotelData((prevData) => ({ ...prevData, checkOutButtonStatus: newCheckedValue }));

    try {
      const response = await patchApi(`api/hotel/editCheckOutButtonStatus/${hotel?.hotelId}`, {
        status: newCheckedValue
      });
      console.log('Check-Out Response:', response);
    } catch (error) {
      console.error('Error updating check-out status:', error);
    }
  };

  if (loading) return <Typography>Loading...</Typography>;

  return (
    <>
      <EditHotel open={openEdit} handleClose={handleCloseEditHotel} data={hotelData} />
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between' }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example" textColor="secondary" indicatorColor="secondary">
              <Tab label="Hotel Profile" value="1" />
              <Tab label="WhatsApp API Message Status" value="2" />
            </TabList>
            <div>
              <Button
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                sx={{ marginLeft: 2, color: '#673ab7', borderColor: '#673ab7' }}
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
            </div>
          </Box>

          <TabPanel value="1">
            <Box sx={{ flexGrow: 1, overflowX: 'auto' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <Item sx={{ height: '100%' }}>
                    <Grid>
                      <Item>
                        <Typography variant="h4">View Details</Typography>
                        <hr />
                        <Grid container spacing={2} sx={{ justifyContent: 'between', alignItems: 'center', marginTop: '1px' }}>
                         <Grid item xs={12} md={12}>
                          {hotelData?.hotelImage&&  <img width={250} height={200} src={`https://neorooms.in/api/${hotelData?.hotelImage}`}/>}
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <Typography variant="h5">Hotel Name</Typography>
                            <Typography style={{ color: 'black' }}>{hotelData?.name ? hotelData?.name : 'N/A'}</Typography>
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <Typography variant="h5">Email</Typography>
                            <Typography style={{ color: 'black' }}>{hotelData?.email ? hotelData?.email : 'N/A'}</Typography>
                          </Grid>
                        </Grid>
                        <Grid container spacing={2} sx={{ justifyContent: 'between', alignItems: 'center', marginTop: '1px' }}>
                          <Grid item xs={6} md={6}>
                            <Typography variant="h5">Phone Number</Typography>
                            <Typography style={{ color: 'black' }}>{hotelData?.contact ? hotelData?.contact : 'N/A'}</Typography>
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <Typography variant="h5">Address</Typography>
                            <Typography style={{ color: 'black' }}>{hotelData?.address ? hotelData?.address : 'N/A'}</Typography>
                          </Grid>
                        </Grid>
                        <Grid container spacing={2} sx={{ justifyContent: 'between', alignItems: 'center', marginTop: '1px' }}>
                          <Grid item xs={6} md={6}>
                            <Typography variant="h5">GST Number</Typography>
                            <Typography style={{ color: 'black' }}>{hotelData?.gstNumber ? hotelData?.gstNumber : 'N/A'}</Typography>
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <Typography variant="h5">GST Percentage on Food</Typography>
                            <Typography style={{ color: 'black' }}>
                              {hotelData?.foodgstpercentage ? hotelData?.foodgstpercentage : 'N/A'}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <Typography variant="h5">GST Percentage on Rooms</Typography>
                            <Typography style={{ color: 'black' }}>
                              {hotelData?.roomgstpercentage ? hotelData?.roomgstpercentage : 'N/A'}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <Typography variant="h5">Currency Code</Typography>
                            <Typography style={{ color: 'black' }}>
                              {hotelData?.currencyCode ? hotelData?.currencyCode : 'N/A'}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <Typography variant="h5">Check-In Time</Typography>
                            <Typography style={{ color: 'black' }}>{hotelData?.checkInTime ? hotelData?.checkInTime : 'N/A'}</Typography>
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <Typography variant="h5">Website URL</Typography>
                            <Typography style={{ color: 'black' }}>{hotelData?.websiteURL ? hotelData?.websiteURL : 'N/A'}</Typography>
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <Typography variant="h5">Google Map URL</Typography>
                            <Typography style={{ color: 'black' }}>{hotelData?.mapurl ? hotelData?.mapurl : 'N/A'}</Typography>
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <Typography variant="h5">Google Review URL</Typography>
                            <Typography style={{ color: 'black' }}>
                              {hotelData?.googleReviewURL ? hotelData?.googleReviewURL : 'N/A'}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <Typography variant="h5">Check-In Time</Typography>
                            <Typography style={{ color: 'black' }}>{hotelData?.checkInTime ? hotelData?.checkInTime : 'N/A'}</Typography>
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <Typography variant="h5">Check-Out Time</Typography>
                            <Typography style={{ color: 'black' }}>{hotelData?.checkOutTime ? hotelData?.checkOutTime : 'N/A'}</Typography>
                          </Grid>
                        </Grid>
                      </Item>
                    </Grid>
                    <Grid container spacing={2} sx={{ justifyContent: 'between', alignItems: 'center', marginTop: '1px' }}>
                      <Grid item xs={12} md={12} sx={{ display: 'flex', justifyContent: 'end', gap: 3 }}>
                        <Button
                          startIcon={<EditIcon />}
                          variant="outlined"
                          sx={{ marginLeft: 2, color: '#673ab7', borderColor: '#673ab7' }}
                          onClick={handleOpenEditHotel}
                        >
                          Edit
                        </Button>
                      </Grid>
                    </Grid>
                  </Item>
                </Grid>
              </Grid>
            </Box>
          </TabPanel>

          <TabPanel value="2">
            <Box sx={{ flexGrow: 1, overflowX: 'auto' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <Item sx={{ height: '100%' }}>
                    <Grid>
                      <Item>
                        <Typography variant="h4">WhatsApp Message Disable / Enable</Typography>
                        <hr />
                        <Grid container spacing={2} sx={{ justifyContent: 'between', alignItems: 'center', marginTop: '1px' }}>
                          <Grid item xs={6} md={6}>
                            <Typography variant="h5">Check-In Message Button</Typography>
                          </Grid>

                          <Grid item xs={6} md={6}>
                            <FormGroup>
                              <FormControlLabel
                                control={<Switch checked={hotelData?.checkInButtonStatus} onChange={handleChangeForCheckInButton} />}
                              />
                            </FormGroup>
                          </Grid>

                          <Grid item xs={6} md={6}>
                            <Typography variant="h5">Check-Out Message Button</Typography>
                          </Grid>

                          <Grid item xs={6} md={6}>
                            <FormGroup>
                              <FormControlLabel
                                control={<Switch checked={hotelData?.checkOutButtonStatus} onChange={handleChangeForCheckOutButton} />}
                              />
                            </FormGroup>
                          </Grid>
                        </Grid>
                      </Item>
                    </Grid>
                  </Item>
                </Grid>
              </Grid>
            </Box>
          </TabPanel>
        </TabContext>
      </Box>
    </>
  );
}
